export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-orkut-ad47b1fc554f06c4c0d887730a4a37c6.svg";